import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
@Injectable({
  providedIn: 'root'
})
export class TranslationService  {
  
  private readonly LANG_KEY = 'selectedLanguage'; 

  constructor(private _translate: TranslateService) {
    this._translate.setDefaultLang('en');
    const savedLang = this.getStoredLanguage() || 'en'; 
    this.setLanguage(savedLang);
  }

  setLanguage(lang: string): void {
    this._translate.use(lang);
    localStorage.setItem(this.LANG_KEY, lang); 
  }

  getStoredLanguage(): string | null {
    return localStorage.getItem(this.LANG_KEY);
  }

  getCurrentLanguage(): string {
    return this._translate.currentLang;
  }

  translate(key: string, params?: { [key: string]: any }): string {
    const currentTranslation = this._translate.instant(key, params);
  
    // Check if the translation is missing (null, undefined, or empty)
    if (!currentTranslation || currentTranslation.trim() === "") {
      const defaultLang = this._translate.getDefaultLang();
      const currentLang = this._translate.currentLang;

      this._translate.use(defaultLang);

      const fallbackTranslation = this._translate.instant(key, params);

      this._translate.use(currentLang);
  
      return fallbackTranslation || key; 
    }
  
    return currentTranslation;
  }
  
}
